import React from 'react';
import { useTranslation } from 'react-i18next';
import DocsLayout, {
  NavSection
} from '../../common/components/docs-layout.component';

// Sidebar labels are keyed under subdivsDocs.layout.*. The same keys are reused
// as the page headings (H2) they point at, so the TOC and the heading can never
// drift apart in any language. The anchor ids are load-bearing (cross-page
// links point at them) — never translate or rename them.
const SubdivsDocsLayout: React.FC = () => {
  const { t } = useTranslation();

  const NAV_SECTIONS: NavSection[] = [
    {
      title: t('subdivsDocs.layout.sectionTitle'),
      items: [
        { label: t('subdivsDocs.layout.overview'), to: '/squarebit-subdivs/docs' },
        {
          label: t('subdivsDocs.layout.gettingStarted'),
          children: [
            {
              label: t('subdivsDocs.layout.installation'),
              to: '/squarebit-subdivs/docs/installation'
            },
            {
              label: t('subdivsDocs.layout.licensing'),
              to: '/squarebit-subdivs/docs/licensing'
            }
          ]
        },
        {
          label: t('subdivsDocs.layout.geometryCaches'),
          to: '/squarebit-subdivs/docs/geometry-caches',
          subItems: [
            {
              label: t('subdivsDocs.layout.importSettings'),
              anchor: 'import-settings'
            },
            { label: t('subdivsDocs.layout.adding'), anchor: 'adding' },
            { label: t('subdivsDocs.layout.keySettings'), anchor: 'key-settings' },
            { label: t('subdivsDocs.layout.quadCages'), anchor: 'quad-cages' }
          ]
        },
        {
          label: t('subdivsDocs.layout.skeletalMeshes'),
          to: '/squarebit-subdivs/docs/skeletal-meshes',
          subItems: [
            { label: t('subdivsDocs.layout.adding'), anchor: 'adding' },
            { label: t('subdivsDocs.layout.hotkeys'), anchor: 'hotkeys' },
            { label: t('subdivsDocs.layout.multiMesh'), anchor: 'multi-mesh' },
            { label: t('subdivsDocs.layout.keySettings'), anchor: 'key-settings' },
            { label: t('subdivsDocs.layout.quadCages'), anchor: 'quad-cages' }
          ]
        },
        {
          label: t('subdivsDocs.layout.staticMeshes'),
          to: '/squarebit-subdivs/docs/static-meshes',
          subItems: [
            { label: t('subdivsDocs.layout.adding'), anchor: 'adding' },
            { label: t('subdivsDocs.layout.quads'), anchor: 'quads' },
            { label: t('subdivsDocs.layout.keySettings'), anchor: 'key-settings' },
            { label: t('subdivsDocs.layout.quadCages'), anchor: 'quad-cages' }
          ]
        },
        {
          label: t('subdivsDocs.layout.grooms'),
          to: '/squarebit-subdivs/docs/grooms',
          subItems: [
            { label: t('subdivsDocs.layout.prereqs'), anchor: 'prereqs' },
            { label: t('subdivsDocs.layout.bind'), anchor: 'bind' },
            { label: t('subdivsDocs.layout.behavior'), anchor: 'behavior' },
            { label: t('subdivsDocs.layout.settings'), anchor: 'settings' }
          ]
        }
      ]
    }
  ];

  return <DocsLayout navSections={NAV_SECTIONS} />;
};

export default SubdivsDocsLayout;
